import { InfoBarMessageWithShowDetailsActionProps } from './InfoBarMessageWithShowDetailsAction';
import * as React from 'react';

export interface InfobarShowHideDetailsPartProps extends InfoBarMessageWithShowDetailsActionProps {
    clickHandler: (evt: React.MouseEvent<EventTarget>) => void;
    isShowingDetails: boolean;
}

const InfobarShowHideDetailsPart = (props: InfobarShowHideDetailsPartProps) => {
    const { isShowingDetails, clickHandler, detailsElement } = props;

    return (
        <span>
            <a href={'javascript:void(0);'} className={props.className} onClick={clickHandler}>
                {isShowingDetails ? props.hideDetailsText : props.showDetailsText}
            </a>
            {isShowingDetails && detailsElement}
        </span>
    );
};

export default InfobarShowHideDetailsPart;
